module.exports = __webpack_public_path__ + "assets/icons/pulse-logo.a01747f78d7e5db3ba0d3910482ad2b5.svg";